import { render, staticRenderFns } from "./ProductRowFive.vue?vue&type=template&id=05613bdf&scoped=true"
import script from "./ProductRowFive.vue?vue&type=script&lang=js"
export * from "./ProductRowFive.vue?vue&type=script&lang=js"
import style0 from "./ProductRowFive.vue?vue&type=style&index=0&id=05613bdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05613bdf",
  null
  
)

export default component.exports